import React, { FC, Fragment } from "react";
import { FormControl, RadioGroup } from "@material-ui/core";
import { useStyles } from "../../useStyles";
import { ChangeNames, ChangeTypes } from "../../clients/FirebaseClient/types";
import { useFormModel } from "../core/FormModelHelpes";
import { FormControlLabel } from "../core/FormControlLabel";
import { Radio } from "../core/Radio";

const convertValue = (value: ChangeTypes[ChangeNames.REMOVAL_POWER_SUBJECT]["value"]): string => {
    if (value.cableDisassembly) {
        return "cable disassembly";
    } else if (value.roofPillarDisassembly) {
        return "roof pillar disassembly";
    }
    return "";
};

export const RemovalPowerSubjectForm: FC = () => {
    const { values, setValues, submitChange } = useFormModel<ChangeNames.REMOVAL_POWER_SUBJECT>();
    const classes = useStyles();
    const selection = convertValue(values.removalPowerSubject.value);
    return (
        <Fragment>
            <h4 className={classes.h4} style={{ marginBottom: 0, marginTop: 50 }}>
                Welche Arbeiten sollen am Stromnetzanschluss durchgeführt werden?
            </h4>
            <FormControl
                component="fieldset"
                className={classes.container}
                style={{ display: "flex" }}
            >
                <RadioGroup
                    value={selection}
                    onChange={(e, v) => {
                        const newValues = setValues(values => {
                            values.removalPowerSubject.value.cableDisassembly =
                                v.indexOf("cable disassembly") >= 0;
                            values.removalPowerSubject.value.roofPillarDisassembly =
                                v.indexOf("roof pillar disassembly") >= 0;
                        });
                        submitChange(newValues);
                    }}
                >
                    <FormControlLabel
                        value="cable disassembly"
                        control={<Radio />}
                        label="Demontage eines in der Erde verlegten Kabels"
                        error={values.removalPowerSubject.error !== null}
                    />
                    <FormControlLabel
                        value="roof pillar disassembly"
                        control={<Radio />}
                        label="Demontage eines Dachständers"
                        error={values.removalPowerSubject.error !== null}
                    />
                </RadioGroup>
            </FormControl>
        </Fragment>
    );
};
